// import { ModalJobListStoreInterface } from '@/store/ModalJobListStore'
// import { modalJobListStore } from '@/utils/store-accessor'

export class ModalJobListService {
  public open() {
    // modalJobListStore.open()
  }

  public close() {
    // modalJobListStore.close()
  }
}
